import { render, staticRenderFns } from "./forgetPass.vue?vue&type=template&id=71bc786a&scoped=true"
import script from "./forgetPass.vue?vue&type=script&lang=js"
export * from "./forgetPass.vue?vue&type=script&lang=js"
import style0 from "./forgetPass.vue?vue&type=style&index=0&id=71bc786a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71bc786a",
  null
  
)

export default component.exports